import React, { ReactNode } from 'react'

import { SxProps } from '@mui/material'

import List from 'components_new/atoms/List'
import Skeleton from 'components_new/atoms/Skeleton'

import ContentBox from 'components_new/molecules/ContentBox'
import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'
import { SectionHeaderProps } from 'components_new/molecules/SectionHeader'
import GenericListItem from 'components_new/molecules/GenericListItem'

import { useTranslation } from 'language/translator'
import { useAdmins } from 'redux/hooks/Accounts'
import { formatUsername } from 'utils/functions'

interface AdminListProps {
  collapse?: {
    active: boolean
    defaultCollapsed?: boolean
    unmountOnExit?: boolean
  }
  header?: ReactNode | SectionHeaderProps
  helperText?: ReactNode | string
  size?: 'small' | 'medium' | 'large'
  sx?: SxProps
}

const AdminList = (props: AdminListProps) => {
  const { collapse, header, helperText, size = 'medium', sx } = props

  const { t, translateEnum } = useTranslation()
  const { accounts: admins, loading } = useAdmins()

  return (
    <ContentBox
      collapse={collapse}
      color="default"
      header={header}
      helperText={helperText}
      sx={sx}
    >
      {loading ? (
        <Loading />
      ) : admins.length === 0 ? (
        <EmptyPlaceholder
          background={true}
          title={t('users', 'no_system_admin')}
        />
      ) : (
        <List dense={true}>
          {admins.map((user) => (
            <GenericListItem
              body={
                // skip body for size small
                size === 'small'
                  ? undefined
                  : translateEnum('account_roles', user.role).title
              }
              key={user.id}
              size={size}
              title={formatUsername(user)}
              variant="user"
            />
          ))}
        </List>
      )}
    </ContentBox>
  )
}

const Loading = () => (
  <>
    {[1, 2].map((i) => (
      <Skeleton height={40} key={i} sx={{ mb: 1 }} />
    ))}
  </>
)

export default AdminList
